export default __webpack_public_path__ + "static/career-video-bg-1292e60db8f1afc7581f1bd2ea291d41.png";